import { AxiosError } from "axios";

export interface NestError {
  statusCode: number;
  message: string | string[];
  error: string;
}

export const nestErrorMessage = (
  error: AxiosError<NestError>,
  fallback = "Votre action n'a pas pu être prise en compte.",
) => {
  const message = error.response?.data?.message;

  if (!message) return fallback;

  return Array.isArray(message) ? message.join(", ") : message;
};
